const REGION_ID = "site-live-region";

// One polite live region for the whole site, outside the React root so it never affects hydration.
export function ensureLiveRegion() {
  if (typeof document === "undefined") {
    return null;
  }
  let region = document.getElementById(REGION_ID);
  if (!region) {
    region = document.createElement("div");
    region.id = REGION_ID;
    region.className = "sr-only";
    region.setAttribute("role", "status");
    region.setAttribute("aria-live", "polite");
    region.setAttribute("aria-atomic", "true");
    document.body.appendChild(region);
  }
  return region;
}

export function announce(message) {
  const region = ensureLiveRegion();
  if (!region) {
    return;
  }
  // Clear first so repeating the same message is announced again.
  region.textContent = "";
  window.setTimeout(() => {
    region.textContent = message;
  }, 50);
}
